module.exports = __webpack_public_path__ + "static/djangoworkshop-b4a97a030285302eeeb3211089cc2441.webp";